<div class="wrapper">
  <google-chart [data]="chartData"></google-chart>
  <div *ngIf="(store.getGemiddeldGebruik() | async) != null " class="extra-info">
  	<span id="getal">{{store.getGemiddeldGebruik() | async}}</span>
  	<span id="ondertekst">leerlingen gemiddeld actief per dag</span>
  </div>
</div>


